import { TableItem } from 'components/atoms';
import { FormInput } from 'components/molecules';
import { Table } from 'components/organisms';
import { useFormikContext } from 'formik';
import { IFormikContextType } from 'hooks/useFormikField';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { IAccountMutationForm } from 'services/accounts/types';
import { useGetStatementTemplates } from 'services/enums';

export const statementTemplateInitialValues = {
  statementTemplateName: '',
  available: true,
};

const AccountStatementTemplates = () => {
  const {
    values,
    status,
    setFieldValue,
    initialValues,
  }: IFormikContextType<IAccountMutationForm> =
    useFormikContext<IAccountMutationForm>();

  const { t } = useTranslation();
  const statementTemplates = useGetStatementTemplates();

  useEffect(() => {
    if (
      statementTemplates.data?.filter(t => t.name !== 'Default').length !==
      values.availableStatementTemplates.length
    ) {
      setFieldValue(
        'availableStatementTemplates',
        statementTemplates.data
          ?.map(statementTemplate => ({
            templateName: statementTemplate.name,
            available:
              initialValues.availableStatementTemplates.find(
                a => a.templateName === statementTemplate.name && a.available,
              )?.available ??
              initialValues.availableStatementTemplateIds.includes(
                statementTemplate.id,
              ),
          }))
          .filter(a => a.templateName !== 'Default') ?? [],
      );
    }
  }, [
    statementTemplates.data?.length,
    initialValues.availableStatementTemplates?.length,
    values.availableStatementTemplates.length,
  ]);

  return (
    <Table
      id={'AccountStatementTemplates2'}
      size='compact'
      data={{
        nodes: values.availableStatementTemplates.map((s, index) => ({
          ...s,
          id: index,
        })),
      }}
      loading={statementTemplates.isLoading}
      columns={[
        {
          label: 'Statement template',
          renderCell: ({ templateName }) => (
            <TableItem justifyPosition='start'>
              <TableItem.Text text={templateName} />
            </TableItem>
          ),
          resize: true,
        },
        {
          label: t('input.label.available'),
          renderCell: ({ available, id }) => (
            <TableItem justifyPosition='start'>
              <FormInput.Checkbox
                name={`availableStatementTemplates[${id}].available`}
                label={available ? t('input.label.available') : 'Not available'}
              />
            </TableItem>
          ),
        },
      ]}
    />
  );
};

export default AccountStatementTemplates;
